import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./Snackbar'),
  loading: () => null,
});
